import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Input } from "@/components/ui/Input";
import { Label } from "@/components/ui/Label";
import { Button } from "@/components/ui/Button";
import {
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/Card";

import { endpoints } from "@/api/endpoints";
import { SUPABASE } from "@/lib/db";
import { CenteredCard } from "@/components/CenteredCard";
import { authenticatedRequestBody } from "@/api/services/auth";

function getRedirectTo(): string | null {
  const params = new URLSearchParams(window.location.search);
  return params.get("redirect_to");
}

function isAllowedRedirect(url: string) {
  return (
    url.startsWith("https://estimate.nestrr.net") ||
    url.startsWith("https://www.nestrr.net") ||
    url.startsWith("http://localhost:3000")
  );
}

export const FirstLogin = () => {
  const navigate = useNavigate();

  const [user_name, setName] = useState("");
  const [company, setCompany] = useState("");
  const [position, setPosition] = useState("");
  const [industry, setIndustry] = useState("");

  const redirectTo = useMemo(() => {
    const raw = getRedirectTo();
    if (!raw) return null;
    return isAllowedRedirect(raw) ? raw : null;
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    await SUPABASE.auth.refreshSession();

    const session_data = await authenticatedRequestBody({
      name: user_name,
      company: company,
      position: position,
      industry: industry,
    });

    await fetch(endpoints.update_metadata, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: session_data,
    });

    if (redirectTo) {
      window.location.assign(redirectTo);
      return;
    }

    navigate("/app");
  };

  return (
    <CenteredCard>
      <CardHeader>
        <CardTitle>Welcome</CardTitle>
        <CardDescription>
          Please fill out some basic information before continuing.
        </CardDescription>
      </CardHeader>

      <form onSubmit={handleSubmit}>
        <CardContent>
          <div>
            <Label>Name</Label>
            <Input
              type="text"
              className="min-w-full"
              placeholder="First Last"
              value={user_name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          <div>
            <Label>Industry</Label>
            <Input
              type="text"
              className="min-w-full"
              placeholder="Your Industry (ie: Signage, Construction, etc)"
              value={industry}
              onChange={(e) => setIndustry(e.target.value)}
              required
            />
          </div>

          <div>
            <Label>Company</Label>
            <Input
              type="text"
              className="min-w-full"
              placeholder="Your Company Name"
              value={company}
              onChange={(e) => setCompany(e.target.value)}
            />
          </div>

          <div>
            <Label>Position / Role</Label>
            <Input
              type="text"
              className="min-w-full"
              placeholder="Your position / role in your company"
              value={position}
              onChange={(e) => setPosition(e.target.value)}
            />
          </div>
        </CardContent>

        <CardFooter className="flex justify-end">
          <Button type="submit">Continue</Button>
        </CardFooter>
      </form>
    </CenteredCard>
  );
};
